/**
 * Types of exhibition: articles normal exhibition composed by users
 * virtually exhibition glossar and calendarEvents and root which contains impressum,
 * data protection and exhibition overview
 *
 */

export const articles = 'articles';
export const glossary = 'glossary';
export const calendar = 'calendar';
export const root = 'root';
